// NSICRegistration.jsx
import React from "react";

export default function NSICRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            NSIC Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            NSIC Registration for MSMEs
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides assistance for NSIC Registration to
            help MSMEs access government procurement benefits, tender exemptions,
            and various MSME support schemes under the Single Point Registration
            Scheme (SPRS).
          </p>
          <p className="text-gray-700">
            The registration process is managed with attention to Udyam
            compliance, document structuring, and NSIC portal requirements to
            ensure your MSME qualifies for government contracts and support
            programs.
          </p>
        </div>

        {/* Right: Image (NSIC REGISTRATION MSME - manufacturing/small business government scheme) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3183151/pexels-photo-3183151.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="MSME obtaining NSIC Registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks offers comprehensive support for NSIC
              Registration under the Single Point Registration Scheme, helping
              MSMEs unlock government tender opportunities and support benefits.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Eligibility verification for MSME status and NSIC SPRS
                  requirements including Udyam compliance and operational track
                  record.
                </li>
                <li>
                  Complete application preparation including online portal
                  registration, form filling, and document upload management.
                </li>
                <li>
                  Coordination with NSIC zonal offices for queries, verifications,
                  and certificate issuance processing.
                </li>
                <li>
                  Renewal support and compliance advisory to maintain continuous
                  NSIC registration benefits and government procurement access.
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for NSIC Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in organizing the core MSME documents
              required for successful NSIC Single Point Registration application.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Valid MSME/Udyam Registration Certificate.</li>
                <li>PAN card of the business entity and proprietors/partners.</li>
                <li>
                  Business registration proof (Partnership Deed, Incorporation
                  Certificate, or Proprietorship Declaration).
                </li>
                <li>
                  Proof of business premises (ownership documents or lease
                  agreement).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in MSME compliance with proven expertise in NSIC
              registration processes and government procurement requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  MSME Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep understanding of Udyam requirements, NSIC SPRS
                  eligibility, and government procurement tender processes for
                  MSMEs.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional document structuring and verification to meet NSIC
                  standards and ensure smooth application processing.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from eligibility assessment through NSIC
                  certificate issuance and ongoing renewal management.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Unlock NSIC Benefits for Your MSME
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to complete your NSIC
                Registration and access government tenders, EMD exemptions, and
                MSME support schemes for business growth.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
